import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Container, Stack, Toolbar } from '@mui/material';

import { Authenticated } from '@modules/Auth/components';

import { Header } from '..//Header';
import { NavigationSidebar } from '../NavigationSidebar';


const STANDALONE_ROUTES = ['/programs'];

export const MainLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [navigationOpen, setNavigationOpen] = React.useState(false);
  const location = useLocation();

  const isStandalone = STANDALONE_ROUTES.some(route => location.pathname.startsWith(route));

  const openNavigation = () => {
    setNavigationOpen(true);
  };

  const closeNavigation = () => {
    setNavigationOpen(false);
  };

  const toggleNavigation = () => {
    setNavigationOpen(open => !open);
  };

  if (isStandalone) {
    return (
      <Box component="main" width="100%">
        {children}
      </Box>
    );
  }

  return (
    <React.Fragment>
      <Authenticated>
        <Header onNavigationClickRequest={toggleNavigation}/>
      </Authenticated>
      <Stack direction="row">
        <Authenticated>
          <NavigationSidebar open={navigationOpen} onOpenRequest={openNavigation} onCloseRequest={closeNavigation}/>
        </Authenticated>
        <Box component="main" width="100%">
          <Toolbar/>
          <Container maxWidth={false}>
            <Stack py={{ xs: 2, sm: 4 }} px={{ xs: 0, sm: 2 }} alignItems="center">
              {children}
            </Stack>
          </Container>
        </Box>
      </Stack>
    </React.Fragment>
  );
};
